var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public-container"},[(_vm.apiDown)?_c('error',{attrs:{"error-type":"expired","message":'This link has expired'}}):_vm._e(),(!_vm.apiDown && _vm.publicInfo)?_c('public-page',{attrs:{"publicInfo":_vm.publicInfo,"displayButtons":_vm.displayButtons}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }